import {
  format,
  parseISO,
  startOfMonth,
  addMonths,
  isBefore,
  isSameMonth,
} from "date-fns";

interface MonthlyData {
  date: string;
  fees: number;
}

interface ChartDataPoint {
  date: string;
  fees: number;
}

export const generateCompleteChartData = (
  monthlyData: MonthlyData[],
  startDate?: string,
  endDate?: string
): ChartDataPoint[] => {
  if (!monthlyData || monthlyData.length === 0) {
    return [];
  }

  // Determine date range
  let rangeStart: Date;
  let rangeEnd: Date;

  if (startDate && endDate) {
    // Use provided date range (for AnalyticsPage)
    rangeStart = startOfMonth(parseISO(startDate));
    rangeEnd = startOfMonth(parseISO(endDate));
  } else {
    // Auto-determine range from data (for DashboardPage)
    const dates = monthlyData.map((stat) => parseISO(stat.date));
    rangeStart = startOfMonth(
      new Date(Math.min(...dates.map((d: Date) => d.getTime())))
    );
    rangeEnd = startOfMonth(
      new Date(Math.max(...dates.map((d: Date) => d.getTime())))
    );
  }

  // Create a map of existing data for quick lookup
  const existingDataMap = new Map<string, number>();
  monthlyData.forEach((stat) => {
    const monthKey = format(parseISO(stat.date), "yyyy-MM");
    existingDataMap.set(monthKey, stat.fees);
  });

  // Generate all months in the range
  const completeData: ChartDataPoint[] = [];
  let current = rangeStart;

  while (isBefore(current, rangeEnd) || isSameMonth(current, rangeEnd)) {
    const monthKey = format(current, "yyyy-MM");
    const displayDate = format(current, "MMM yyyy");

    completeData.push({
      date: displayDate,
      fees: existingDataMap.get(monthKey) || 0,
    });

    current = addMonths(current, 1);
  }

  return completeData;
};
